import cx from 'classnames';
import React from 'react';

import './detailed-view__content.scss';

interface Props {
    children: React.ReactNode | Array<React.ReactNode>;
    mix?: string;
}

export const LessonViewDetailedViewContent = React.forwardRef(({ children, mix }: Props) => {
    return <div className={cx('detailed-view__content', mix)}>{children}</div>;
});
